// Guest Pages
const layout = "Guest"
export default [
	{
		path: "/login",
		name: "Login",
		component: () => import("@/views/LoginPage"),
		meta: { layout },
	},
	{
		path: "/register",
		name: "Register",
		component: () => import("@/views/RegisterPage"),
		meta: { layout },
	},
	{
		path: "/forget-password",
		name: "ForgetPassword",
		component: () => import("@/views/ForgetPassword"),
		meta: { layout },
	},
	{
		path: "/confirm-user",
		name: "ConfirmUser",
		component: () => import("@/views/ConfirmUser"),
		meta: { layout },
	},
	{
		path: "/reset-password",
		name: "ResetPassword",
		component: () => import("@/views/ResetPassword"),
		meta: { layout },
	},

]